import styled from "styled-components";

// The wrapper every page sits in.
//
// There used to be five near-copies of this, which is why the pages did not
// agree with each other: Charts padded itself to 20% a side on wide screens and
// Watchlist used a 2rem margin, so one page was two thirds the width of the
// others and another started 16px further down. Sharing it means a change to
// the page gutter happens once.
//
// 20px on the sides lines the content up with the logo in the header. The top
// padding is deliberately tight - the heading should sit just under the nav,
// not float below it.
export const PageContainer = styled.div`
  width: 100%;
  padding: 0.75rem 20px 2rem;

  @media (max-width: 650px) {
    padding-left: 12px;
    padding-right: 12px;
  }
`;

export const NewsIcons = styled.div`
  display: flex;
  flex-direction: row;
  width: 90%;
  padding: 0.3rem 0.5rem 0.2rem 0.5rem;
  height: 65px;

  @media (max-width: 991px) {
  }
  @media (max-width: 767px) {
    padding: 0.3rem 0.3rem 0.2rem 0.3rem;
  }
  @media (max-width: 650px) {
    padding: 0.2rem;

    margin-bottom: 0.1rem;
  }

  @media (max-width: 350px) {
    padding-right: 0rem;
  }
`;
export const NewsHeader = styled.div`
  display: flex;
  justify-content: flex-start;
  font-weight: 200;
  height: 85px;
  padding-bottom: 0.1rem;
  margin-top: 0.2rem;
  margin-right: 0.4rem;
  margin-left: 0.4rem;
  overflow: hidden;

  a {
    cursor: pointer;
    color: #e8e9ed;
    height: fit-content;
    text-align: left;
  }
  @media (max-width: 650px) {
    overflow: visible;
  }
`;
export const Image = styled.img`
  display: flex;
  width: 100%;
  height: auto;
  max-height: 200px;

  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  &:hover {
    background-color: transparent !important;
  }
  @media (max-width: 650px) {
    display: flex;
    width: 100%;
    height: auto;
    max-height: 250px;

    padding: 0;
    margin-bottom: 2rem;
    margin-bottom: 0 !important;
  }
`;
export const TopStoryImageContainer = styled.a`
  width: 100%;
`;
export const LoadingWrapper = styled.div`
  align-items: start;
  justify-content: center;
  width: 100%;
  display: flex;
`;

export const BtcBalPara = styled.p`
  font-size: 25px;
  color: green;
  margin-bottom: 0.2rem;
`;

export const UsdBalPara = styled.p`
  font-size: 20px;
  color: green;
  margin-bottom: 0.2rem;
`;

